// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-panel {
  width: var(--side-panel-width);
  transition: width 0.35s ease;
  overflow: hidden;
  background: var(--card-bg);
  border-left: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  /* Matches its flex parent (.map-page), which is already sized to
     "one screen minus the header" — not the full 100vh. */
  height: 100%;
  box-sizing: border-box;
}

.side-panel.is-closed {
  width: 0;
  border-left: none;
}

.side-panel-inner {
  width: var(--side-panel-width);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.side-panel-header {
  flex-shrink: 0;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.side-panel-lock-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  padding: 6px 6px;
  transition: background 0.2s ease;
  gap: 6px;
  color: var(--text-secondary);
  font-size: 13px;
}
.side-panel-lock-toggle:hover {
  background: var(--hover);
}

.side-panel-close-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  padding: 8px;
  transition: background 0.2s ease;
  color: var(--primary);
}
.side-panel-close-btn:hover {
  background: var(--hover);
}

.side-panel-open-btn {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  padding: 0;
  color: var(--primary);
}
.side-panel-open-btn:hover {
  background: var(--hover);
}

.side-panel-handle {
  display: flex;
  width: 32px;
  border-left: 1px solid var(--border);
  background: var(--card-bg);
  flex-shrink: 0;
}

.side-panel-content {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
  color: var(--text-secondary);
  line-height: 1.5;
}

.side-panel-content h4 {
  margin-top: 0;
}

.side-panel-placeholder {
  color: var(--text-muted);
}

/* =========================================================
   RESPONSIVE — phones & small tablets
   The panel becomes a slide-over drawer instead of squeezing
   the map into a sliver of the screen.
   ========================================================= */
@media (max-width: 768px) {
  .side-panel {
    position: fixed;
    top: var(--header-height);
    right: 0;
    height: calc(100vh - var(--header-height));
    z-index: 1150;
    box-shadow: -4px 0 24px var(--shadow-lg);
    width: min(85vw, var(--side-panel-width));
  }

  .side-panel.is-closed {
    width: 0;
    box-shadow: none;
  }

  .side-panel-inner {
    width: min(85vw, var(--side-panel-width));
  }

  .side-panel-handle {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    height: 56px;
    border-radius: var(--radius-md) 0 0 var(--radius-md);
    box-shadow: -2px 0 12px var(--shadow);
    z-index: 1400;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SidePanel.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd;0DACwD;EACxD,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,QAAQ;EACR,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;EACpC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;8DAI8D;AAC9D;EACE;IACE,eAAe;IACf,yBAAyB;IACzB,QAAQ;IACR,0CAA0C;IAC1C,aAAa;IACb,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,oDAAoD;IACpD,qCAAqC;IACrC,aAAa;EACf;AACF","sourcesContent":[".side-panel {\n  width: var(--side-panel-width);\n  transition: width 0.35s ease;\n  overflow: hidden;\n  background: var(--card-bg);\n  border-left: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  /* Matches its flex parent (.map-page), which is already sized to\n     \"one screen minus the header\" — not the full 100vh. */\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.side-panel.is-closed {\n  width: 0;\n  border-left: none;\n}\n\n.side-panel-inner {\n  width: var(--side-panel-width);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.side-panel-header {\n  flex-shrink: 0;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.side-panel-lock-toggle {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 6px 6px;\n  transition: background 0.2s ease;\n  gap: 6px;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.side-panel-lock-toggle:hover {\n  background: var(--hover);\n}\n\n.side-panel-close-btn {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 8px;\n  transition: background 0.2s ease;\n  color: var(--primary);\n}\n.side-panel-close-btn:hover {\n  background: var(--hover);\n}\n\n.side-panel-open-btn {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease;\n  padding: 0;\n  color: var(--primary);\n}\n.side-panel-open-btn:hover {\n  background: var(--hover);\n}\n\n.side-panel-handle {\n  display: flex;\n  width: 32px;\n  border-left: 1px solid var(--border);\n  background: var(--card-bg);\n  flex-shrink: 0;\n}\n\n.side-panel-content {\n  padding: 16px;\n  overflow-y: auto;\n  flex: 1;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.side-panel-content h4 {\n  margin-top: 0;\n}\n\n.side-panel-placeholder {\n  color: var(--text-muted);\n}\n\n/* =========================================================\n   RESPONSIVE — phones & small tablets\n   The panel becomes a slide-over drawer instead of squeezing\n   the map into a sliver of the screen.\n   ========================================================= */\n@media (max-width: 768px) {\n  .side-panel {\n    position: fixed;\n    top: var(--header-height);\n    right: 0;\n    height: calc(100vh - var(--header-height));\n    z-index: 1150;\n    box-shadow: -4px 0 24px var(--shadow-lg);\n    width: min(85vw, var(--side-panel-width));\n  }\n\n  .side-panel.is-closed {\n    width: 0;\n    box-shadow: none;\n  }\n\n  .side-panel-inner {\n    width: min(85vw, var(--side-panel-width));\n  }\n\n  .side-panel-handle {\n    position: fixed;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    height: 56px;\n    border-radius: var(--radius-md) 0 0 var(--radius-md);\n    box-shadow: -2px 0 12px var(--shadow);\n    z-index: 1400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
